import {
  MAP_CALLOUT_MODE_THRESHOLDS,
  type CalloutMode,
} from '@/core/constants/dashboard-map.constants';
import type { DashboardMapItem } from '@/core/interfaces/Dashboard';

export type { CalloutMode };

/**
 * Adaptive callout density from visible marker count.
 * Default card content is always compact (name + inventory);
 * full details only on hover/selection regardless of mode.
 */
export function resolveCalloutMode(markerCount: number): CalloutMode {
  if (markerCount <= MAP_CALLOUT_MODE_THRESHOLDS.full) {
    return 'compact';
  }
  if (markerCount <= MAP_CALLOUT_MODE_THRESHOLDS.compact) {
    return 'compact';
  }
  if (markerCount <= MAP_CALLOUT_MODE_THRESHOLDS.labelOnly) {
    return 'label-only';
  }
  return 'selected-only';
}

export function shouldRenderCallout(
  marker: DashboardMapItem,
  mode: CalloutMode,
  selectedMarkerId: number | null,
  hoveredMarkerId: number | null = null
): boolean {
  const isActive =
    selectedMarkerId === marker.id || hoveredMarkerId === marker.id;

  if (mode === 'selected-only') {
    return isActive;
  }

  return true;
}

/**
 * Compact by default (name + inventory).
 * Hover/selection keep the same compact mode for layout; card UI shows address on hover.
 */
export function resolveCalloutDisplayMode(
  mode: CalloutMode,
  marker: DashboardMapItem,
  selectedMarkerId: number | null,
  hoveredMarkerId: number | null = null
): CalloutMode {
  const isActive =
    selectedMarkerId === marker.id || hoveredMarkerId === marker.id;

  if (isActive && mode === 'selected-only') {
    return 'compact';
  }

  if (isActive && mode === 'label-only') {
    return 'compact';
  }

  return mode === 'selected-only' ? 'compact' : mode;
}
